//--------------------PAGE ROUTES-----------------------------------
export const PATH_DASHBOARD = window.location.origin + '/Home/Landing';
export const PATH_ACCOUNT_LOGOFF = window.location.origin + '/Account/Logoff/';

// LOGIN UI login/logout routes & paths
export const ROUTE_LOGIN_EXPIRED = '/ui/login/expired';
export const ROUTE_LOGIN_LOGOUT = '/ui/login/logout';
export const PATH_LOGIN_EXPIRED = window.location.origin + ROUTE_LOGIN_EXPIRED;
export const PATH_LOGIN_LOGOUT = window.location.origin + ROUTE_LOGIN_LOGOUT;

//-------------------FEATURE TOGGLES---------------------------------
export const REQUIRE_AUTH = true;